import $ from 'jquery';
import axios from "axios";

$(function() {

    // $('.liame').nospam({ filterLevel: 'normal',replaceText: true  });
    // $('.email').nospam({ filterLevel: 'normal',replaceText: false  });

    $(".hvrproduct").hover(function() {
        $(this).find(".hvrproductover").fadeToggle(500);
    });

    $('.slider').slick({
        autoplay: true,
        autoplaySpeed: 1800,
        infinite: true,
        fade: true,
        dots: false,
        arrows: true,
        speed: 1600,
        prevArrow: '<button type="button" class="slick-prev" aria-label="previous"></button>',
        nextArrow: '<button type="button" class="slick-next" aria-label="next"></button>',
    });

    $('.banner').slick({
        autoplay: true,
        autoplaySpeed: 1800,
        infinite: true,
        fade: true,
        dots: false,
        arrows: false,
        speed: 1600,
    });

    // $(function(){  // $(document).ready shorthand
    //$('#prodimg').hide().fadeIn('slow');
    // $('#prodimg').hide().delay(1000).fadeIn('slow');
    // });

    //$(".slick-prev").hover(function() {
    //	$(this).animate({
    //		width: 22, height: 39
    //	}, 500, function() {
    //		$(this).animate({
    //			width: 29, height: 51
    //		}, 500, function() {
    //			pulse();
    //		});
    //	});
    //});

    $("#toTop").click(function(){
        //event.preventDefault();
        $("html, body").animate({
            scrollTop:0
        },"slow");
    });

    $('.qtyplus').click(function(e){
        e.preventDefault();
        fieldID = $(this).attr('field');
        var currentVal = parseInt($('input[id='+fieldID+']').val());
        if (!isNaN(currentVal)) {
            $('input[id='+fieldID+']').val(currentVal + 1);
        } else {
            $('input[id='+fieldID+']').val(1);
        }
    });
    $(".qtyminus").click(function(e) {
        e.preventDefault();
        fieldID = $(this).attr('field');
        var currentVal = parseInt($('input[id='+fieldID+']').val());
        if (!isNaN(currentVal) && currentVal > 1) {
            $('input[id='+fieldID+']').val(currentVal - 1);
        } else {
            $('input[id='+fieldID+']').val(1);
        }
    });

    $('.autoplay').slick({
        autoplay: false,
        autoplaySpeed: 2500,
        centerMode: true,
        infinite: true,
        fade: true,
        dots: false,
        speed: 1600,
        appendArrows: $('.slider-buttons'),
        dotsClass: 'slick-dots page-widthn page-center' //allows for moving on product pages
    });

    //$("button.slick-next").hover(function() {
    //	$(this).toggleClass("bouncing");
    //});

    //$("button.slick-prev").hover(function() {
    //	$(this).toggleClass("bouncing");
    //});

    if (typeof $.fn.masonry !== 'undefined') {
        $('.knowus-wrapper').masonry({
            // options
            itemSelector: '.knowus-panel',
            columnWidth: '.knowus-sizer',
            percentPosition: true
        });

        if ($('.knowus-wrapper').length > 0) {
            $('.knowus-content').each(function() {
                var
                    x1 = 1000-(Math.random()*2000),
                    y1 = 1000-(Math.random()*2000),
                    x2 = 1000-(Math.random()*2000),
                    y2 = 1000-(Math.random()*2000);

                $(this).css({
                    'background-position': x1+'px '+y1+'px, '+x2+'px '+y2+'px'
                });

            });
        }
    }

    // Buy item ajax functionality
    var addedPopupHtml = false;

    /*
    $("form input[type=image]").click(function() {
        $("input[type=image]", $(this).parents("form")).removeAttr("clicked");
        $(this).attr("clicked", "true");
    });
    */

    $('form[name="AddBasket"] input[type=submit], .tabproductadd > form input[type=submit], form[name^="buyform_"] input[type=submit]').click(function() {
        $(this).removeClass('clicked');
        $(this).addClass("clicked");
        $(this).val("ORDERED");
    });

    $('form[name="AddBasket"], .tabproductadd > form, form[name^="buyform_"]').submit(function(){
        var val = $("input[type=submit]").val();

        if (val == "ADD TO WISH LIST"){
        } else {
            // this file is included before linkPath is defined
            // setup ajax Object
            var $SubmittedQty = $(this).find("input[name=Qty]");
            if ($.isNumeric($SubmittedQty.val()))
            {if ($SubmittedQty.val() == 0) {$SubmittedQty.val('1')};
            } else
            {$SubmittedQty.val('1')};
            var serialiseData = "Ajax_AddToBasket=1&" + $(this).serialize();

            var basketupdatepage = 0;
            if (serialiseData.indexOf("basketupdate") !== -1) {basketupdatepage = 1} ;
            var request = $.ajax({
                url: $(this).attr('action'),
                type: $(this).attr('method'),
                dataType: "json",
                cache: false,
                data: serialiseData,
                success: function(response){

                    if (response.basketinfo[0].current_basket_value !== undefined){
                        var newCurrentBasketValue = response.basketinfo[0].current_basket_value;
                        var current_basket_Wascommitted	= response.basketinfo[0].current_basket_committed;
                        var current_basket_commit_datestamp	= response.basketinfo[0].current_basket_commit_datestamp;

                        if (basketupdatepage == 1) {FetchBasket();};
                    }

                    if (basketupdatepage == 0){
                        //do we have a time for the commit?
                        if (current_basket_commit_datestamp.includes(":")){
                            var sPopupTitle = "You have added an item to your current order";
                            if (current_basket_Wascommitted =="1"){
                                var sPopupMessage = "<p>You have just added an item to your <a href='/basket.asp'>current order</a>.</p><p>You have until <b>" + current_basket_commit_datestamp + "</b> to make any amends. After this time it will be processed by our team.</p>";
                            } else {
                                var sPopupMessage = "<p>You have just added an item to your <a href='/basket.asp'>current order</a>.</p><p style='color:red'>Your previously committed order is on hold while you amend it. <br /><b>You must hit Place Order on the current order page</b> again to ensure it is processed by our team.</p>";
                            }
                            var newCurrentBasketCount = 'Current Order for processing at ' + current_basket_commit_datestamp + ' (' + response.basketinfo[0].current_basket_count + ')';
                        } else {
                            var sPopupTitle = "Added to basket";
                            var sPopupMessage = "<p>You have just added that item into your <a href='/basket.asp'>basket</a></p>";
                            var newCurrentBasketCount = 'Basket (' + response.basketinfo[0].current_basket_count + ')';
                        }

                        sPopupMessage = sPopupMessage.concat("<p><a href='#' class='jqmClose'>Continue browsing</a></p>");

                        if (!addedPopupHtml) {
                            $('#footer_wrapper_outer').append('<div class="jqmWindow" id="popuptext"><h3>' + sPopupTitle + '</h3><div>' + sPopupMessage  + '</div></div>');
                            addedPopupHtml = true;
                        } else {
                            $('#popuptext').html('<h3>' + sPopupTitle + '</h3><div>' + sPopupMessage  + '</div>');
                        }
                    }

                    var myClose=function(hash) {
                        hash.w.fadeOut('2000',function(){ hash.o.remove(); });
                    };
                    $('#current_basket_count span.headerbasketinfo').html(newCurrentBasketCount);
                    $('#current_basket_value').fadeOut(300).fadeIn(300).fadeOut(300).fadeIn(300);
                    $('#current_basket_count').fadeOut(300).fadeIn(300).fadeOut(300).fadeIn(300);

                    $('#popuptext').jqm({overlay:60,toTop:true,onHide:myClose}).jqmShow({});
                }
            });
            return false;
        }
    });

    $('img.whopanelimg').hover(function(){
        //$(this).toggleClass("grayscale", 500)
        $(this).toggleClass("fullcolor");
        //alert('hello');
    });

    menuLoad();

});


(function(d) {
    var config = {
            kitId: 'qra5rqp',
            scriptTimeout: 3000,
            async: true
        },
        h=d.documentElement,t=setTimeout(function(){h.className=h.className.replace(/\bwf-loading\b/g,"")+" wf-inactive";},config.scriptTimeout),tk=d.createElement("script"),f=false,s=d.getElementsByTagName("script")[0],a;h.className+=" wf-loading";tk.src='https://use.typekit.net/'+config.kitId+'.js';tk.async=true;tk.onload=tk.onreadystatechange=function(){a=this.readyState;if(f||a&&a!="complete"&&a!="loaded")return;f=true;clearTimeout(t);try{Typekit.load(config)}catch(e){}};s.parentNode.insertBefore(tk,s)
})(document);



$(function() {
    var trans = null;
    var hasBanner = $('.content-wrapper.hasBanner').length > 0;

    var scrollfunc = function() {
        var scrolltop = $(document).scrollTop();

        $('.header').toggleClass('small', scrolltop > 43); // 139 - 89 = 43px


        if (!hasBanner) {
            var sh = 132;
            var pct = (Math.min(scrolltop, sh)/sh) * 0.26;
            if (!isFinite(pct))
                pct = 0;

            pct = 1 - pct;
            if (trans != pct) {
                trans = pct;
                // JM commented out for IE8
                //$('.header').css({
                //	background: 'rgba(0, 55, 38, '+(pct)+')'
                //});
            }
        }

    };

    // $(window).scroll(scrollfunc);
    // scrollfunc();
});

//nav stuff
$(function() {
    $('.nojs').removeClass('nojs');

    var open = null;
    var megamenu = $('.megamenu');
    var megawrapper = $('.megamenu-wrapper');


    var openMenu = function(el, callback) {

        var li = $(el).closest('li');
        var submenu = $(li).find('ul').eq(0);
        megamenu.html('');
        submenu.clone().appendTo(megamenu);
        $('<div class="clear">').appendTo(megamenu);

        megawrapper.fadeIn(1000, function() {
            open = $(el);
            if (callback) callback(el);
        });


    }

    var closeMenu = function(el, callback) {
        megawrapper.fadeOut(1000, function() {
            open = null;
            if (callback) callback(el);
        });
    }


    $('.nav .menu_depth_0 li.menuclass_megamenu a').mouseover(function() {
        if (open && open.is($(this))) return; //already open

        var el = $(this);

        if (open) {
            closeMenu(el, function() {
                openMenu(el);
            });
        }
        else {
            openMenu(el);
        }
    });


    /*
        menu hiding logic, don't hide if the user is hover over a menu entry or megamenu
        http://stackoverflow.com/a/5018955/7003388
    */
    var hoverCount = 0;
    $('.nav > .menu_depth_0 > li.menuclass_megamenu > a, .megamenu-wrapper')
        .mouseover(function() {
            hoverCount ++;
            //console.log(hoverCount);
        })
        .mouseout(function() {
            hoverCount --;
            //console.log(hoverCount);
            setTimeout(function() {
                //console.log('after', hoverCount);
                if (!hoverCount) {
                    closeMenu();
                }
            }, 100);
        });

    /*
        var toggle = function() {
            if ($('body').is('.bmenu')) return true;

            var li = $(this).closest('li');
            var submenu = $(li).find('ul').eq(0);
            var megamenu = $('.megamenu');
            var megawrapper = $('.megamenu-wrapper');

            megawrapper.finish();

            //called either instantly, or after existing megamenu has slidden up
            var docontents = function() {
                megamenu.html('');
                submenu.clone().appendTo(megamenu);
                $('<div class="clear">').appendTo(megamenu);

                megawrapper.fadeIn(500);
            }

            if (megawrapper.is(':visible')) {
                if ($(li).is(open)) {
                    console.log(li, open);
                    megawrapper.fadeOut(500);
                    open = null;
                }
                else {
                    open = null;

                    megawrapper.fadeOut(500, docontents);
                }
            }
            else {
                docontents();
                open = $(li);
            }
        };
        */

});

$(function() {
    var drop = $('.headersearch-drop');
    var box = drop.find('input');
    // search stuff in header
    $('.headersearch-toggle').click(function() {
        box.focus();
    });

    drop.focusin(function() {
        drop.toggleClass('collapsed', false);
    });

    drop.focusout(function() {
        setTimeout(function() {
            if (!drop.is(':focus')) {
                drop.toggleClass('collapsed', true);
            }
        }, 500);
    });

});

$(function() {
    $(document).on('click', '.nav-toggle-dropdown', function() {
        $(this).siblings('.nav-sub-menu').toggleClass('open');
        $(this).toggleClass('active');
    });
});

$(document).on('click', '.toggle-nav button', function() {
    $('body').toggleClass('nav-toggled');
});

$('a[href$="#"]').click(function (event) {
    event.preventDefault ? event.preventDefault() : event.returnValue = false;
});

// let headerHeight = $('.header').outerHeight();
// $(window).scroll(function(){
    // if ($(window).scrollTop() >= headerHeight) {
    //     $('body').addClass('scrolled');
    //     $('#main').css('paddingTop', headerHeight);
    // } else {
    //     $('body').removeClass('scrolled');
    //     $('#main').css('paddingTop', '0');
    // }
// });

//$(function() {
//	$('.contentmenu .default').click(function() {
//		var menu = $(this).closest('.contentmenu');
//		var content = $(menu).find('>ul');
//		if (content.is(':visible')) {
//			menu.toggleClass('expanded', false);
//			content.slideUp();
//		}
//		else {
//			menu.toggleClass('expanded', true);
//			content.slideDown();
//		}
//	});
//});


$(function() {
    $('.careers-panel .image').click(function() {
        var section = $(this).closest('.careers-panel');
        var image = $(this);
        var editorial = section.find('.editorial');

        var expanded = section.hasClass('expanded');

        editorial.stop();
        section.stop();

        section.toggleClass('expanded', !expanded);
        editorial.slideToggle(expanded);

    });
});

/*
 * Accept cookies popup
 */
$(document).on('click', '.accept_cookies', function() {
    axios.get('/manager/accept-cookies')
        .then(function (response) {console.log(response);
            $('.cookie-banner').fadeOut();
        })
        .catch(function(error) {
            console.log(error);
        });
});

/*
 * Age verification
 */
$(document).on('click', '.age-verification-submit', function() {
    let answer = $(this).val();
    let url = 'https://www.drinkaware.co.uk';

    if(answer !== 'y') {

        window.location.href = url;

    } else {

        axios.post('/verify-age', {
            answer: answer
        })
            .then(function (response) {
                $('#age-verification').fadeOut();
            })
            .catch(function (error) {
                console.log(error);
            });

    }
});

// /*
//  * No Spam (1.3.2)
//  */
// (function ($) {
//     $.fn.nospam = function (settings) {
//         settings = $.extend({
//             replaceText: false, // optional, accepts true or false
//             filterLevel: 'normal' // optional, accepts 'low' or 'normal'
//         }, settings);
//         return this.each(function () {
//             e = null;
//             if (settings.filterLevel == 'low') { // Can be a switch() if more levels added
//                 if ($(this).is('a[rel]')) {
//                     e = $(this).attr('rel').replace('//', '@').replace(/\//g, '.');
//                 } else {
//                     e = $(this).text().replace('//', '@').replace(/\//g, '.');
//                 }
//             } else { // 'normal'
//                 if ($(this).is('a[rel]')) {
//                     e = $(this).attr('rel').split('').reverse().join('').replace('//', '@').replace(/\//g, '.');
//                 } else {
//                     e = $(this).text().split('').reverse().join('').replace('//', '@').replace(/\//g, '.');
//                 }
//             }
//             if (e) {
//                 if ($(this).is('a[rel]')) {
//                     $(this).attr('href', 'mailto:' + e);
//                     if (settings.replaceText) {
//                         $(this).text(e);
//                     }
//                 } else {
//                     $(this).text(e);
//                 }
//             }
//         });
//     };
// })(jQuery);

//jqModal
// (function(e){e.fn.jqm=function(t){return this.each(function(){var n=e(this),r=n.data("jqm")||e.extend({ID:c++},e.jqm.params),i=e.extend(r,t);n.data("jqm",i).addClass("jqm-init");i.trigger&&n.jqmAddTrigger(i.trigger)})};e.fn.jqmAddTrigger=function(n){return this.each(function(){if(!o(e(this),"jqmShow",n))t("jqmAddTrigger must be called on initialized modals")})};e.fn.jqmAddClose=function(n){return this.each(function(){if(!o(e(this),"jqmHide",n))t("jqmAddClose must be called on initialized modals")})};e.fn.jqmShow=function(t){return this.each(function(){!this._jqmShown&&n(e(this),t)})};e.fn.jqmHide=function(t){return this.each(function(){this._jqmShown&&r(e(this),t)})};var t=function(e){if(window.console&&window.console.error)window.console.error(e)},n=function(t,n){var r=t.data("jqm"),n=n||window.event,i=parseInt(t.css("z-index")),i=i>0?i:3e3,s=e("<div></div>").addClass(r.overlayClass).css({height:"100%",width:"100%",position:"fixed",left:0,top:0,"z-index":i-1,opacity:r.overlay/100}),o={w:t,c:r,o:s,t:n};t.css("z-index",i);if(r.ajax){var a=r.target||t,f=r.ajax;a=typeof a=="string"?e(a,t):e(a);if(f.substr(0,1)=="@")f=e(n).attr(f.substring(1));a.html(r.ajaxText).load(f,function(){r.onLoad&&r.onLoad.call(this,o);u(o)})}else{u(o)}},r=function(e,t){var n=e.data("jqm"),t=t||window.event,r={w:e,c:n,o:e.data("jqmv"),t:t};a(r)},i=function(t){if(t.c.overlay>0)t.o.prependTo("body");t.w.show();e.jqm.focusFunc(t.w);return true},s=function(e){e.w.hide()&&e.o&&e.o.remove();return true},o=function(t,n,r){var i=t.data("jqm");if(!t.data("jqm"))return false;return e(r).each(function(){this[n]=this[n]||[];if(e.inArray(i.ID,this[n])<0){this[n].push(i.ID);e(this).click(function(){var e=this;t[n](this);return false})}})},u=function(t){var n=t.w,r=t.o,i=t.c;if(i.onShow(t)!==false){n[0]._jqmShown=true;if(i.modal){!h[0]&&f("bind");h.push(n)}else n.jqmAddClose(r);i.closeClass&&n.jqmAddClose(e("."+i.closeClass,n));i.toTop&&r&&n.before('<span id="jqmP'+i.ID+'"></span>').insertAfter(r);n.data("jqmv",r)}},a=function(t){var n=t.w,r=t.o,i=t.c;if(i.onHide(t)!==false){n[0]._jqmShown=false;if(i.modal){h.pop();!h[0]&&f("unbind")}i.toTop&&r&&e("#jqmP"+i.ID).after(n).remove()}},f=function(t){e(document)[t]("keypress keydown mousedown",l)},l=function(t){var n=e(t.target).data("jqm")||e(t.target).parents(".jqm-init:first").data("jqm"),r=h[h.length-1].data("jqm");if(n&&n.ID==r.ID)return true;return e.jqm.focusFunc(r)},c=0,h=[];e.jqm={params:{overlay:50,overlayClass:"jqmOverlay",closeClass:"jqmClose",trigger:".jqModal",ajax:false,target:false,ajaxText:"",modal:false,toTop:false,onShow:i,onHide:s,onLoad:false},focusFunc:function(t){e(":input:visible:first",t).focus();return false}}})(jQuery)

function menuLoad() {

    // Highlight current menu item (for cached menus)

    // Clear any highlighted menu items
    $('li a.on').removeClass('on');

    // Get the current path
    let pathname = [window.location.pathname];
    if (pathname[0] === '/') {
        pathname.push('/homepage');
    }

    // Highlight any menu item links to the current path
    pathname.forEach(function(item) {
        $('li a[href=\'' + item + '\']').addClass('on');
    });

}
